/**
 * AED currency helpers — iter-202 policy.
 *
 * Rule: All AED amounts are FLOORED to fils (2 decimals). NEVER rounded.
 * Applies to: wallet, orders, commissions, withdrawals, invoices + VAT,
 * discounts, reports, notifications — every place we display or compute money.
 *
 * BANNED patterns (produce rounding artifacts):
 *   - Number(x).toFixed(2)          → rounds
 *   - Math.round(x * 100) / 100     → rounds
 *   - Number(x).toLocaleString()    → rounds
 *
 * Example: 16,478.52 × 7% = 1,153.4964 → floorAED → 1,153.49  (NOT 1,153.50)
 */

/**
 * Floor a number to fils (2 decimal places, truncated toward zero on
 * the magnitude). Returns 0 for non-finite input.
 */
export function floorAED(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return 0;
  const sign = v < 0 ? -1 : 1;
  // 1e-6 safety margin against floating-point artifacts
  return (sign * Math.floor(Math.abs(v) * 100 + 1e-6)) / 100;
}

/**
 * Format an AED amount with grouping separators and always 2 fixed decimals,
 * applying the flooring rule. Does NOT append the currency symbol —
 * callers can render "د.إ" / "AED" themselves.
 */
export function fmtAED(n) {
  return floorAED(n).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
